import React from 'react';
import { Activity } from 'lucide-react';
import { EMPTY_STATES } from '../../design-system/content';

export function EmptyState() {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6 msml-fade-in" data-testid="empty-state">
      <div className="w-16 h-16 rounded-2xl bg-[var(--msml-primary-muted)] flex items-center justify-center mb-5">
        <Activity className="w-7 h-7 text-[var(--msml-primary)] opacity-40" />
      </div>
      <h3 className="text-base font-medium text-[var(--msml-text-secondary)] mb-1">{EMPTY_STATES.workspace.title}</h3>
      <p className="text-sm text-[var(--msml-text-muted)] max-w-xs">{EMPTY_STATES.workspace.body}</p>
    </div>
  );
}

export function ErrorState({ message, onDismiss }) {
  return (
    <div className="flex items-center gap-2 p-3 rounded-md bg-[var(--msml-danger-bg)] border border-[var(--msml-danger)]/20 msml-fade-in" data-testid="analysis-error">
      <span className="text-sm text-[var(--msml-danger)] flex-1">{message}</span>
      {onDismiss && <button onClick={onDismiss} className="text-xs text-[var(--msml-danger)] hover:underline">Dismiss</button>}
    </div>
  );
}

export function LoadingSkeleton() {
  return (
    <div className="space-y-4 msml-fade-in" data-testid="loading-skeleton">
      <div className="msml-card !p-5 text-center">
        <div className="w-16 h-3 bg-white/10 rounded mx-auto mb-3 animate-pulse" />
        <div className="w-20 h-12 bg-white/10 rounded mx-auto mb-2 animate-pulse" />
        <div className="w-24 h-3 bg-white/10 rounded mx-auto animate-pulse" />
      </div>
      <div className="msml-card !p-4">
        <div className="w-20 h-3 bg-white/10 rounded mb-3 animate-pulse" />
        <div className="grid grid-cols-2 gap-2.5">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="p-3 rounded-lg border border-white/[0.06] bg-white/[0.02]">
              <div className="w-16 h-2 bg-white/10 rounded mb-2 animate-pulse" />
              <div className="h-1 bg-white/10 rounded animate-pulse" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
